// extracted by mini-css-extract-plugin
export default {"text":"UpsaleBonusDialog__text--1x7vG"};